import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ServiceTypeEnum from '../../../../Enums/ServiceTypeEnum';
import selectHelper from '../../../../Helpers/selectHelper';
import {
  specialLocationsOptionsArray,
  locationTypeOptionsArray,
  tabletOrPaperOptionsArray,
  locationOrEntranceOptionsArray,
  bareOrClientSurveyArray,
  locationListSourceArray,
  surveyReportDeliverArray,
  timeConstraintsMaxLength,
} from './SharedConstants';

const interceptsPages = [
  {
    label: 'Fieldwork Requirements',
    hide: (item) => item.TypeCode != ServiceTypeEnum.FaceToFaceIntercepts,
    fields: [
      {
        fieldName: 'TimeConstraints',
        label: 'Visit Time Constraints (days/hours/etc)',
        className: 'col-12',
        type: InputTypesEnum.Text,
        maxLength: timeConstraintsMaxLength,
      },
      {
        fieldName: 'SurveyReportDeliver',
        label: 'Survey Report Deliver',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(surveyReportDeliverArray.map((s) => s.label)),
      },
      {
        fieldName: 'SpecialLocations',
        label: 'Select Special Locations if Applicable',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: specialLocationsOptionsArray,
      },
      {
        fieldName: 'LocationType',
        label: 'Location Type (select all that apply)',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: locationTypeOptionsArray,
      },
      {
        fieldName: 'LocationTypeDetails',
        label: 'Location Type Details',
        className: 'col-12',
        type: InputTypesEnum.TextBox,
        hide: (item) => !item.LocationType || !item.LocationType.includes('Other'),
      },
      {
        fieldName: 'LocationListSource',
        label: 'Location List Source',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(locationListSourceArray.map((l) => l.label)),
      },
    ],
  },
  {
    label: 'Program Approach',
    hide: (item) => item.TypeCode != ServiceTypeEnum.FaceToFaceIntercepts,
    fields: [
      {
        fieldName: 'NumResponsesRequested',
        label: 'Number of responses requested',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumLocations',
        label: 'Number of locations',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumInterviewersPerLocation',
        label: 'Number of interviewers per location',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'LengthOfSurvey',
        label: 'Length of survey',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'TabletOrPaper',
        label: 'Tablet or paper?',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(tabletOrPaperOptionsArray.map((t) => t.label)),
      },
      {
        fieldName: 'InLocationOrEntrance',
        label: 'In the location/store or entrance?',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(locationOrEntranceOptionsArray.map((l) => l.label)),
      },
      {
        fieldName: 'AuthorizationLetterProvided',
        label: 'Authorization letter provided?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'IncentivesDescription',
        label: 'Incentive (please describe)',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'IncentiveCoordinationDescription',
        label: "If there are incentives, how will IC's coordinate incentive distribution?",
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'IccoordinatorBilingualRequired',
        label: 'Does IC coordinator need to be bilingual?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'BareOrClientSurvey',
        label: 'BARE provides survey or Client provides survey',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(bareOrClientSurveyArray.map((b) => b.label)),
      },
      {
        fieldName: 'IncentiveProvidedByBare',
        label: 'Incentive provided by BARE?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
    ],
  },
  {
    label: 'Survey',
    hide: (item) => item.TypeCode != ServiceTypeEnum.FaceToFaceIntercepts,
    fields: [
      {
        fieldName: 'NumClosedQuestions',
        label: 'No. Closed Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumOpenQuestions',
        label: 'No. Simple Text Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumNarrativeQuestions',
        label: 'No. Narrative Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'QuestionnaireProvided',
        label: 'Questionnaire Provided by Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'TranslationProvided',
        label: 'Translation of Questionnaire Provided by Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'GuidelinesProvided',
        label: 'Guidelines Provided by Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
    ],
  },
  {
    label: 'Target Respondent Demographics',
    hide: (item) => item.TypeCode != ServiceTypeEnum.FaceToFaceIntercepts,
    fields: [
      {
        fieldName: 'MinAge',
        label: 'Minimum Age',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'MaxAge',
        label: 'Maximum Age',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'GenderCode',
        label: 'Gender',
        className: 'col-12',
        type: InputTypesEnum.CommonGenderLookupItemSelect,
      },
      {
        fieldName: 'OtherDemographicRequirements',
        label: 'Other Demographic Requirements',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
    ],
  },
];

export default interceptsPages;
